export default __webpack_public_path__ + "static/media/05B.030a.8fe4dee2.png";